import React from 'react';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import type { IRowWidget } from './IRowWidget';

export interface IRowWidgetProps extends IWidgetComponentProps<IRowWidget> {}

export function RowWidgetComponent(props: IRowWidgetProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return <>{props.children}</>;
}
